import 'select2/dist/js/select2.full.js'
import 'select2/dist/js/i18n/fr.js'

jQuery('.nav-dropdown select').select2({
    width: '100%',
}).show().on('change', function () {
    window.location = jQuery(this).val()
})

jQuery('.gform_wrapper .ginput_container_select select').select2({
    width: '100%'
})

jQuery('.children_nav_mobile select').select2({
    width: '100%',
}).show().on('change', function () {
    window.location = jQuery(this).val()
})

jQuery('.children_nav_mobile select').select2({
    width: '100%'
})

jQuery('.wppb-select-country select').select2({
    width: '100%',
})

jQuery('.articles_dropdown select').select2({
    width: '100%',
}).show().on('change', function () {
    window.location = jQuery(this).val()
})

jQuery('.variations_form select').select2({
    width: '100%',
}).show()

jQuery('.dashboard_dropdown select').select2({
    width: '100%',
}).show().on('change', function () {
    window.location = jQuery(this).val()
})
